import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pill } from "@faire/retailer-visitor-shared/components/LoggedOutPills/Pill";
import { discoverSearch } from "@faire/retailer-visitor-shared/lib/seoPaths";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import * as componentStyles from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/MoreToExplorePills/styles.css";
import { Carousel } from "@faire/web--source/slate-labs/Carousel/Carousel";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useQuery as usePopularSearchesQuery } from "@faire/web-api--source/api/seo/popular-searches/get-hooks";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import capitalize from "lodash/capitalize";
import React, { useMemo } from "react";
var STALE_TIME = 1000 * 60 * 5;
export var MoreToExplorePills = function() {
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var data = usePopularSearchesQuery({
        max_results: 20
    }, {
        refetchOnMount: false,
        staleTime: STALE_TIME
    }).data;
    var ref = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("perfect_product_banner-explore-more-pill", "".concat(homepageRedesignVariant));
    });
    var popularSearchStrings = data === null || data === void 0 ? void 0 : data.queries;
    var pills = useMemo(function() {
        if (!(popularSearchStrings === null || popularSearchStrings === void 0 ? void 0 : popularSearchStrings.length)) {
            return [];
        }
        return popularSearchStrings.map(function(popularSearchString) {
            return {
                pillContent: capitalize(popularSearchString),
                linkTo: discoverSearch(popularSearchString),
                onClick: function() {
                    trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("perfect_product_banner-explore-more-pill", discoverSearch(popularSearchString), "".concat(homepageRedesignVariant));
                }
            };
        });
    }, [
        popularSearchStrings,
        homepageRedesignVariant
    ]);
    if (!(pills === null || pills === void 0 ? void 0 : pills.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Row, {
        "data-test-id": "more-to-explore-pills",
        align: "center",
        className: componentStyles.pillRow,
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                style: {
                    whiteSpace: "nowrap",
                    paddingRight: getSpacing("2x")
                },
                variant: "paragraphSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "YJ6SKI",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "More to explore"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    overflow: "auto"
                },
                children: /*#__PURE__*/ _jsx(Carousel, {
                    items: pills,
                    renderItem: function(pill) {
                        return /*#__PURE__*/ _jsx(Pill, {
                            pill: pill,
                            className: componentStyles.pill
                        });
                    },
                    freeFlow: true,
                    showNavigationArrows: false,
                    itemGap: {
                        mobileAndAbove: 0
                    },
                    loop: false,
                    onVisible: function() {
                        trackLoggedOutRetailersLoggedOutHomeRedesignView("perfect_product_banner-explore-more-pill-onscroll");
                    }
                })
            })
        ]
    });
};
